import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import classNames from 'classnames'

import { FavoriteIcon, FavoriteEmptyIcon } from 'components/Utils/Icons'
import IconButton from 'components/Utils/IconButton'
import { selectors as UsersSelectors } from 'data/users'
import { selectors as UserPreferencesSelectors } from 'data/userPreferences'
import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'

class Bookmark extends React.Component {
  static propTypes = {
    isBookmarked: PropTypes.bool,
  }

  onClick = () => {
    const {
      noteId,
      isBookmarked,
      updateUserPreferences,
      bookmarkedNoteIds,
    } = this.props
    updateUserPreferences({
      bookmarkedNoteIds: isBookmarked
        ? bookmarkedNoteIds.filter(
            bookmarkedNoteId => bookmarkedNoteId !== noteId
          )
        : bookmarkedNoteIds.add(noteId),
    })
  }

  render() {
    const { isBookmarked } = this.props
    const className = classNames({
      'yellow yellow-on-hover': isBookmarked,
    })
    return (
      <IconButton
        tooltip={isBookmarked ? 'Unfavorite this doc' : 'Favorite this doc'}
        tooltipPosition="left"
        className={className}
        style={{ marginBottom: 2 }}
        onClick={this.onClick}
      >
        {isBookmarked ? (
          <FavoriteIcon size={16} />
        ) : (
          <FavoriteEmptyIcon size={16} />
        )}
      </IconButton>
    )
  }
}

export default compose(
  providesUserPreferencesMutations,
  connect((state, { noteId }) => ({
    isBookmarked: UserPreferencesSelectors.isNoteBookmarked(state, noteId),
    bookmarkedNoteIds: UserPreferencesSelectors.getBookmarkedNoteIds(state),
    userId: UsersSelectors.getCurrentUserId(state),
  }))
)(Bookmark)
